<template>
  <div>
    <v-text-field
      variant="outlined"
      class="login-form"
      v-model="billingDetails.name"
      :rules="[(v) => !!v || 'Name is required']"
      :disabled="billingDetailsData"
    ></v-text-field>

    <v-btn @click="toggleDisable">Toggle Disable</v-btn>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      billingDetails: {
        name: "",
      },
      billingDetailsData: true,
    };
  },
  methods: {
    toggleDisable() {
      this.billingDetailsData = !this.billingDetailsData;
    },



    // geolocation
    // async domainredirect(){
    //   const getConfigResponse = getConfigDataFromLocalStorage();
    //   if(getConfigResponse){
    //     let georedirectUrl = getConfigResponse.payload.portal_configuration.API_endpoints.georedirect;
    //     let portalurlconfig = getConfigResponse.payload.portal_configuration.portal_url;
    //     let portalgroupid = getConfigResponse.payload.portal_configuration.portal_group_id;
    //     let getuseriso = (getConfigResponse.payload.portal_configuration.country.iso_code || null);
    //     let getcountryoptions = (getConfigResponse.payload.portal_configuration.country_options || null);
    //     // let secretqueryKey = "secretenckey";
        
    //     let portaldomain = portalurlconfig;
    //     let portaldomainname = (portalurlconfig.replace("https://","") || null);

    //     let getredirectid = null;
    //     let getrouteiso = null;
    //     let usercountryIso = null;

    //     let findcountry = null;
    //     let findportalurl = null;
    //     let findportalname = null;

    //     console.log(this.$route.query,'getredirectgetredirect...1');
        
    //     if (this.$route.query && this.$route.query.authreq && this.$route.query.authreqid) {
    //       try {
    //         getrouteiso = (this.$route.query.authreq || null);
    //         getredirectid = (this.$route.query.authreqid || null);

    //         // Decryption
    //         if(getrouteiso){
    //           usercountryIso = (CryptoJS.enc.Base64.parse(getrouteiso).toString(CryptoJS.enc.Utf8) || null);
    //           console.log(usercountryIso,'getredirectgetredirect...2');
    //         }
    //         // Decryption End
    //         if(usercountryIso && getcountryoptions){
    //           findcountry = (getcountryoptions.find((v)=>v.country_code == usercountryIso) || null);
    //           findportalurl = findcountry ? findcountry.portal_url : null;
    //           findportalname = findcountry ? findcountry.portal_url.replace("https://","") : null;
    //         }

    //       } catch (e) {
    //         console.log("Invalid redirectid value:", this.$route.query);
    //         getrouteiso = null;
    //         getredirectid = null;
    //       }
    //     }
    //     else if (this.$route.query && this.$route.query.authreqid && !this.$route.query.authreq) {
    //       try {
    //         getredirectid = (this.$route.query.authreqid || null);
    //       } catch (e) {
    //         console.log("Invalid redirectid value:", this.$route.query);
    //         getredirectid = null;
    //       }
    //     }
    //     else{
    //       getredirectid = null;
    //       getrouteiso = null;
    //     }
  
    //     // Get redirect type from router for Manual Redirection
    //     let getredirecttype = null;
    //     if (this.$route.query && this.$route.query.redirect) {
    //       try {
    //         getredirecttype = JSON.parse(this.$route.query.redirect);
    //       } catch (e) {
    //         console.log("Invalid redirect type value:", this.$route.query.redirect);
    //         getredirecttype = null;
    //       }
    //     }
    //     // Get redirect type from router for Manual Redirection ... End ...

    //     console.log(this.$route.query,'getredirectgetredirect...3',getrouteiso);
    //     console.log(this.$route.query,'getredirectgetredirect...4',getredirectid);

    //     let localorigin = (window.location.origin || null);
    //     if(localorigin && localorigin.includes('localhost')){
    //       this.redirectReq.payload.ip = "";
    //     }
  
        
    //     // Resquest for Geolocation api
    //     this.redirectReq.payload.requestdomain = findportalurl && getredirectid ? findportalurl :portaldomain;
    //     this.redirectReq.payload.portalname = findportalname && getredirectid ? findportalname : portaldomainname;
    //     this.redirectReq.payload.portaloriginname = portalgroupid;
    //     this.redirectReq.payload.requesttype = getredirecttype ? 'manual' : 'auto';
    //     if(getredirectid) this.redirectReq.payload.redirectid = getredirectid;
    //     // Resquest for Geolocation api End  
    //     console.log(this.redirectReq,'redirectReqsadasdasd');
        
    //     if(georedirectUrl){
    //       axios.post(georedirectUrl,this.redirectReq,{
    //         headers:{
    //           "Content-Type":"application/json"
    //         },
    //       })
    //       .then((response)=>{
    //         console.log(response.data,'responsesdasdasdasd');
    
    //         let getresponse = response.data;
    //         // let georequestdomain = (getresponse.redirect_domain || null);
    //         let geohandleredirect = (getresponse.redirect || null);
    //         let georedirectdomain = (getresponse.redirect_domain || null);
    //         let georedirectId = (getresponse.redirectid || null);
    //         this.handleshowmsg = (getresponse.show_msg || null);
    //         console.log(geohandleredirect,'getredirectgetredirect...5');

    //         console.log(geohandleredirect,this.handleshowmsg,getrouteiso,getredirectid,'getredirectgetredirect...0');
    //         console.log(geohandleredirect,georedirectdomain,georedirectId,getuseriso,this.clickedValue,'getredirectgetredirect...1')

    //         if(geohandleredirect && georedirectdomain && georedirectId && getuseriso){
    //           console.log(georedirectdomain,'getredirectgetredirect...6');  
    //           // Encrypt
    //           let encryptiso = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(getuseriso));
    //           if(encryptiso){
    //             // alert(`${georedirectdomain}?authreq=${encryptiso}&authreqid=${georedirectId}`);
    //             window.location.href = `${georedirectdomain}?authreq=${encryptiso}&authreqid=${georedirectId}`;
    //           }
    //         }
    //         else if(!geohandleredirect && this.handleshowmsg && getrouteiso && getredirectid){
    //           this.geomessage = getresponse.message.text;
    //           this.userDomain = getresponse.message.url;
    //           const getuserdomain = this.userDomain.replace("https://","");
    //           const trimedDomain = getuserdomain.charAt(0).toUpperCase() + getuserdomain.slice(1); 
    //           this.requestdomain = trimedDomain;
    //           console.log(this.geomessage,'getredirectgetredirect...7',this.handleshowmsg);
    //           console.log(this.requestdomain,'getredirectgetredirect...8');
    //           this.dataloader = false;
    //           // alert('sddsdasd...2');
    //         }
    //         else{
    //           this.dataloader = false;
    //           console.log(this.requestdomain,'getredirectgetredirect...9');  
    //           // alert('sddsdasd...3');
    //           sessionStorage.setItem('preferredSite',georedirectdomain)
    //         }
            
    //         // window.addEventListener("beforeunload", () => {
    //         //   if (performance.navigation.type !== 1) {
    //         //     // Remove sessionStorage only if the user is leaving the site (not on reload)
    //         //     sessionStorage.removeItem("hasRedirected");
    //         //     // sessionStorage.removeItem("logoClicked");
    //         //   }
    //         // });
    
    //       })
    //       .catch((error)=>{
    //         this.findpage = false;
    //         this.dataloader = false;
    //         this.envPortal(null);
    //         console.log(error,'errorsdasdasdasda'); 
    //       });
    //     }
    //     else{
    //       this.dataloader = false;
    //       this.envPortal(null);
    //       console.log('errorsdsas'); 
    //     }
    //   }
    // },

    // geolocation ends
  },
};
</script>
